export default __webpack_public_path__ + "static/media/IMG_20372.7fff6d40.jpg";